import
  React
from 'react';

import
  styled
from 'styled-components';

import
  PropTypes
from 'prop-types';

import {
  ColorSvg,
  Text,
  VContainerH,
  VFillContainerVH
} from '@vodacom/web-common';

import {
  CustomColors,
  Icons
} from '../../constants';

import {
  PrimaryButton
} from 'components';

import {
  withScreenViewTagging
} from 'hocs';

const Card = styled(VContainerH)`
  z-index: 5;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const FullScreenCardUI = props => {

    FullScreenCardUI.pageName = props.pageName;

    FullScreenCardUI.tagViewData = {
    ...props.tagViewData
  };

  return (
    <>

      <Card
        backgroundColor={CustomColors.White}
        padding={props.padding}
        maxWidth={props.maxWidth}
        boxSizing={props.boxSizing}
        width={props.width}
        height={props.height} >

        <VFillContainerVH>

          <ColorSvg
            src={Icons.InfoCircle}
            color={CustomColors.Grey11}
            height={props.iconHeight}
            width={props.iconWidth}
            margin={props.iconMargin} />

          {
            props.title &&
            <Text
              fontSize={props.titleFontSize}
              fontWeight={'bold'}
              textAlign={'center'} >

              {props.title}
            </Text>
          }

          <VContainerH
            minHeight={'30%'} >

            <Text
                font-family={props.messageFontFamily}
                fontSize={props.messageFontSize}
                fontWeight={props.messageWeight}
                color={CustomColors.Grey9}
                textAlign={'center'}
                padding={'16px 0'}
                whiteSpace={'pre-wrap'}>

                {props.message}
            </Text>
          </VContainerH>

          <PrimaryButton
            activeBackgroundColor={props.buttonColor}
            activeBorderColor={props.buttonColor}
            width={'100%'}
            maxWidth={'320px'}
            margin={'auto 0 32px'}
            text={props.buttonText}
            onClick={props.onClose}/>

        </VFillContainerVH>
      </Card>
    </>
  );
};

FullScreenCardUI.propTypes = {
  padding: PropTypes.string,
  boxSizing: PropTypes.string,
  maxWidth: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  iconHeight: PropTypes.string,
  iconWidth: PropTypes.string,
  iconMargin: PropTypes.string,
  title: PropTypes.string,
  titleFontSize: PropTypes.string,
  message: PropTypes.string,
  messageFontFamily: PropTypes.string,
  messageWeight: PropTypes.string,
  messageFontSize: PropTypes.string,
  buttonText: PropTypes.string,
  buttonColor: PropTypes.string,
  pageSection: PropTypes.string,
  tagViewData: PropTypes.object,
  pageName: PropTypes.string.isRequired
};

FullScreenCardUI.defaultProps = {
  padding: '20% 36px',
  boxSizing: 'border-box',
  maxWidth: '101%',
  width: '101%',
  height: '100%',
  iconHeight: '100px',
  iconWidth: '100px',
  iconMargin: '32px',
  title: undefined,
  titleFontSize: '20px',
  message: '',
  messageFontFamily: 'Roboto',
  messageWeight: 'normal',
  messageFontSize: '16px',
  buttonText: 'Okay',
  buttonColor: CustomColors.Red1,
  pageSection: 'emergency sms',
  tagViewData: {}
};

export const FullScreenCard = withScreenViewTagging(FullScreenCardUI);